import React from 'react';
import { useTranslation } from 'react-i18next';
import Divider from 'components/Divider/Divider';
import Spinner from 'components/Spinner/Spinner';
import { LargeHeader, Title } from 'components/Text';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import Address from './Address/Address';
import CompanyInfo from './CompanyInfo/CompanyInfo';
import Email from './Email/Email';
import PersonalInfo from './PersonalInfo/PersonalInfo';
import Phone from './Phone/Phone';
import BillingEmail from './BillingEmail/BillingEmail';
export default function Profile() {
  const {
    t
  } = useTranslation();
  const {
    customer,
    loading,
    isBusinessCustomer
  } = useCurrentCustomer();
  if (loading) return /*#__PURE__*/React.createElement(Spinner, null);
  if (!customer && !loading) return /*#__PURE__*/React.createElement(Title, null, t('error.something'));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LargeHeader, null, t('profile.customer_profile')), isBusinessCustomer ? /*#__PURE__*/React.createElement(CompanyInfo, null) : /*#__PURE__*/React.createElement(PersonalInfo, null), /*#__PURE__*/React.createElement(Email, {
    fieldName: isBusinessCustomer ? 'contactEmail' : 'email'
  }), /*#__PURE__*/React.createElement(Phone, {
    fieldName: isBusinessCustomer ? 'contactPhoneNumber' : 'phoneNumber'
  }), /*#__PURE__*/React.createElement(BillingEmail, null), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Address, null));
}